module.exports = __webpack_public_path__ + "static/media/calc.0a51df34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/calc.png
// module id = 692
// module chunks = 0